<template>
  <div id="AttachedFileComponent" class="attached-file-layout">
    <v-card outlined
      ><v-card-title> {{ $t("vendor.headerStep5") }}</v-card-title
      ><v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- Overseas -->
          <v-row v-if="propVendorType === 'oversea'" class="pa-4">
            <v-col cols="12"> <p>KYC From</p></v-col>
            <v-col cols="4">
              <v-btn
                class="mr-4"
                outlined
                color="primary"
                href="/vendor/KYC_Form.pdf"
                download
              >
                Download KYC From
              </v-btn>
            </v-col>
            <v-col cols="4">
              <v-file-input
                v-if="!fileFromKYCRes.hasFile"
                label="Upload KYC From"
                v-model="fileFromKYC.File"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="[
                  (v) => fileValidate(v, 'FromKYC', 'Upload KYC From is required')
                ]"
                :error="!!fileError['FromKYC']"
                :error-messages="fileError['FromKYC'] || ''"
                required
                @change="setModelofFileNew(fileFromKYC.File, 'FromKYC')"
                :append-outer-icon="fileFromKYC.File ? 'mdi-eye' : ''"
                @click:append-outer="viewFilePdf(fileFromKYCRes.File)"
              ></v-file-input>
              <div v-else class="mb-2 d-flex flex-row">
                <v-btn
                  outlined
                  color="secondary"
                  :href="`${apiURl}${fileFromKYCRes.filePath}`"
                  target="_blank"
                  class="mr-4"
                  small
                >
                  <v-icon left> mdi-eye </v-icon>
                  VIEW FILE
                </v-btn>
                <v-btn
                  outlined
                  color="red"
                  small
                  @click="remove('FromKYC', fileFromKYCRes.id)"
                >
                  <v-icon left> mdi-delete </v-icon>
                  REMOVE FILE
                </v-btn>
              </div> </v-col
            ><v-col cols="12"><v-divider class="mb-4"></v-divider> </v-col>
            <v-col cols="12"
              ><v-divider class="mb-4"></v-divider>
              <v-col cols="12">
                <p>
                  Registered capital information according to company
                  certificate
                </p></v-col
              ></v-col
            >
            <v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="descriptionModel.RegisteredCapital"
                :label="$t('vendor.registeredCapitalTxt')"
              ></v-text-field
            ></v-col>
          </v-row>
          <!-- Ordinary -->

          <v-row
            align="center"
            class="pa-4"
            v-if="isOrdinary && propVendorType !== 'oversea'"
          >
            <v-col cols="12">
              <p>{{ $t("vendor.idCard") }}<span>*</span></p></v-col
            >
            <v-col cols="4">
              <v-menu
                ref="menu"
                v-model="menuPickerIdCard"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fileIdCard.ExpireDate"
                    :label="$t('vendor.ExpireDate')"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    required
                    :rules="[(v) => !!v || 'Expire Date is required']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fileIdCard.ExpireDate"
                  :active-picker.sync="activePickerIdCard"
                  min="1950-01-01"
                  @change="save"
                ></v-date-picker> </v-menu></v-col
            ><v-col cols="8">
              <v-file-input
                label="File input"
                v-model="fileIdCard.File"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="[
                  (v) => fileValidate(v, 'IdCard', 'File input is required')
                ]"
                :error="!!fileError['IdCard']"
                :error-messages="fileError['IdCard'] || ''"
                required
                v-if="!fileIdCardRes.hasFile"
                @click="
                  setModelofFileNew(
                    fileIdCard.File,
                    'IdCard',
                    fileIdCard.ExpireDate
                  )
                "
                :append-outer-icon="fileIdCardRes.File ? 'mdi-eye' : ''"
                @click:append-outer="viewFilePdf(fileIdCardRes.File)"
              ></v-file-input>
              <div v-else class="mb-2 d-flex flex-row">
                <v-btn
                  outlined
                  color="secondary"
                  :href="`${apiURl}${fileIdCardRes.filePath}`"
                  target="_blank"
                  class="mr-4"
                  small
                >
                  <v-icon left> mdi-eye </v-icon>
                  VIEW FILE
                </v-btn>
                <v-btn
                  outlined
                  color="red"
                  :disabled="fileIdCardRes.filePath === ''"
                  @click="remove('IdCard', fileIdCardRes.id)"
                  small
                >
                  <v-icon left> mdi-delete </v-icon>
                  REMOVE FILE
                </v-btn>
              </div></v-col
            ><v-col cols="12"><v-divider class="mb-4"></v-divider> </v-col>

            <v-col cols="12">
              <p>{{ $t("vendor.fileCopyBankPassbook") }}</p></v-col
            >
            <v-col cols="4">
              <v-file-input
                label="File input"
                v-if="!fileCopyBankPassbookRes.hasFile"
                v-model="fileCopyBankPassbook.File"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="[
                  (v) => fileValidate(v, 'CopyBankPassbook')
                ]"
                :error="!!fileError['CopyBankPassbook']"
                :error-messages="fileError['CopyBankPassbook'] || ''"
                @change="
                  setModelofFileNew(
                    fileCopyBankPassbook.File,
                    'CopyBankPassbook'
                  )
                "
                :append-outer-icon="fileCopyBankPassbook.File ? 'mdi-eye' : ''"
                @click:append-outer="viewFilePdf(fileCopyBankPassbook.File)"
              ></v-file-input>
              <div v-else class="mb-2 d-flex flex-row">
                <v-btn
                  outlined
                  color="secondary"
                  :href="`${apiURl}${fileCopyBankPassbookRes.filePath}`"
                  target="_blank"
                  class="mr-4"
                  small
                >
                  <v-icon left> mdi-eye </v-icon>
                  VIEW FILE
                </v-btn>
                <v-btn
                  outlined
                  color="red"
                  @click="
                    remove('CopyBankPassbook', fileCopyBankPassbookRes.id)
                  "
                  small
                >
                  <v-icon left> mdi-delete </v-icon>
                  REMOVE FILE
                </v-btn>
              </div></v-col
            ><v-col cols="12"><v-divider class="mb-4"></v-divider> </v-col
            ><v-col cols="12">
              <p>{{ $t("vendor.fileHouseRegistration") }}</p></v-col
            >
            <v-col cols="4">
              <v-file-input
                label="File input"
                v-model="fileHouseRegistration.File"
                v-if="!fileHouseRegistrationRes.hasFile"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="[
                  (v) => fileValidate(v, 'HouseRegistration')
                ]"
                :error="!!fileError['HouseRegistration']"
                :error-messages="fileError['HouseRegistration'] || ''"
                @change="
                  setModelofFileNew(
                    fileHouseRegistration.File,
                    'HouseRegistration'
                  )
                "
                :append-outer-icon="fileHouseRegistration.File ? 'mdi-eye' : ''"
                @click:append-outer="viewFilePdf(fileHouseRegistration.File)"
              ></v-file-input>
              <div v-else class="mb-2 d-flex flex-row">
                <v-btn
                  outlined
                  color="secondary"
                  :href="`${apiURl}${fileHouseRegistrationRes.filePath}`"
                  target="_blank"
                  class="mr-4"
                  small
                >
                  <v-icon left> mdi-eye </v-icon>
                  VIEW FILE
                </v-btn>
                <v-btn
                  outlined
                  color="red"
                  @click="
                    remove('HouseRegistration', fileHouseRegistrationRes.id)
                  "
                  small
                >
                  <v-icon left> mdi-delete </v-icon>
                  REMOVE FILE
                </v-btn>
              </div></v-col
            ><v-col cols="12"><v-divider class="mb-4"></v-divider> </v-col>
          </v-row>

          <!-- Justic Person -->
          <v-row
            align="center"
            class="pa-4"
            v-if="isJuristic && propVendorType !== 'oversea'"
            ><v-col cols="12">
              <p>
                {{ $t("vendor.fileCopyOfVATRegistrationCer") }}
              </p></v-col
            >
            <v-col cols="4">
              <v-file-input
                v-if="!fileCopyOfVATRegistrationCerRes.hasFile"
                label="File input"
                v-model="fileCopyOfVATRegistrationCer.File"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="[
                  (v) => fileValidate(v, 'CopyOfVATRegistrationCer', 'File input is required')
                ]"
                :error="!!fileError['CopyOfVATRegistrationCer']"
                :error-messages="fileError['CopyOfVATRegistrationCer'] || ''"
                required
                @change="
                  setModelofFileNew(
                    fileCopyOfVATRegistrationCer.File,
                    'CopyOfVATRegistrationCer'
                  )
                "
                :append-outer-icon="
                  fileCopyOfVATRegistrationCer.File ? 'mdi-eye' : ''
                "
                @click:append-outer="
                  viewFilePdf(fileCopyOfVATRegistrationCer.File)
                "
              ></v-file-input>
              <div v-else class="mb-2 d-flex flex-row">
                <v-btn
                  outlined
                  color="secondary"
                  :href="`${apiURl}${fileCopyOfVATRegistrationCer.filePath}`"
                  target="_blank"
                  class="mr-4"
                  small
                >
                  <v-icon left> mdi-eye </v-icon>
                  VIEW FILE
                </v-btn>
                <v-btn
                  outlined
                  color="red"
                  small
                  @click="
                    remove(
                      'CopyOfVATRegistrationCer',
                      fileCopyOfVATRegistrationCerRes.id
                    )
                  "
                >
                  <v-icon left> mdi-delete </v-icon>
                  REMOVE FILE
                </v-btn>
              </div> </v-col
            ><v-col cols="12"><v-divider class="mb-4"></v-divider> </v-col>
            <v-col cols="12">
              <p>{{ $t("vendor.fileAffidavit") }}</p></v-col
            >
            <v-col cols="4">
              <v-menu
                ref="menu"
                v-model="menuPickerAffidavit"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fileAffidavit.ExpireDate"
                    label="Issue Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    required
                    :rules="[
                      (v) => !!v || 'Issue Date is required',
                      (v) =>
                        !checkDate(v) ||
                        'หนังสือรับรองบริษัท อายุไม่เกิน 6 เดือน',
                    ]"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fileAffidavit.ExpireDate"
                  :active-picker.sync="activePickerAffidavit"
                  min="1950-01-01"
                  @change="save"
                ></v-date-picker> </v-menu></v-col
            ><v-col cols="4">
              <v-file-input
                label="File input"
                v-model="fileAffidavit.File"
                v-if="!fileAffidavitRes.hasFile"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="[
                  (v) => fileValidate(v, 'Affidavit', 'File input is required')
                ]"
                :error="!!fileError['Affidavit']"
                :error-messages="fileError['Affidavit'] || ''"
                required
                @change="
                  setModelofFileNew(
                    fileAffidavit.File,
                    'Affidavit',
                    fileAffidavit.ExpireDate
                  )
                "
                :append-outer-icon="fileAffidavit.File ? 'mdi-eye' : ''"
                @click:append-outer="viewFilePdf(fileAffidavit.File)"
              ></v-file-input>
              <div v-else class="mb-2 d-flex flex-row">
                <v-btn
                  outlined
                  color="secondary"
                  :href="`${apiURl}${fileAffidavitRes.filePath}`"
                  target="_blank"
                  class="mr-4"
                  small
                >
                  <v-icon left> mdi-eye </v-icon>
                  VIEW FILE
                </v-btn>
                <v-btn
                  outlined
                  color="red"
                  @click="remove('Affidavit', fileAffidavitRes.id)"
                  small
                >
                  <v-icon left> mdi-delete </v-icon>
                  REMOVE FILE
                </v-btn>
              </div></v-col
            ><v-col cols="12"
              ><v-divider class="mb-4"></v-divider>
              <v-col cols="12">
                <p>
                  {{ $t("vendor.registeredCapital") }}
                </p></v-col
              ></v-col
            >
            <v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="descriptionModel.RegisteredCapital"
                :rules="rulesRegisteredCapital"
                :label="$t('vendor.registeredCapitalTxt')"
                required
              ></v-text-field></v-col
            ><v-col cols="12"><v-divider class="mb-4"></v-divider></v-col>
            <v-col cols="12">
              <p>{{ $t("vendor.fileListOfShareholders") }}</p></v-col
            >
            <v-col cols="4">
              <v-menu
                ref="menu"
                v-model="menuPickerIssue"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fileListOfShareholders.ExpireDate"
                    label="Issue Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    required
                    :rules="[(v) => !!v || 'Issue Date is required']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fileListOfShareholders.ExpireDate"
                  :active-picker.sync="activePickerIssue"
                  min="1950-01-01"
                  @change="save"
                ></v-date-picker> </v-menu></v-col
            ><v-col cols="4">
              <v-file-input
                label="File input"
                v-model="fileListOfShareholders.File"
                v-if="!fileListOfShareholdersRes.hasFile"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="[
                  (v) => fileValidate(v, 'ListOfShareholders', 'File input is required')
                ]"
                :error="!!fileError['ListOfShareholders']"
                :error-messages="fileError['ListOfShareholders'] || ''"
                required
                @change="
                  setModelofFileNew(
                    fileListOfShareholders.File,
                    'ListOfShareholders',
                    fileListOfShareholders.ExpireDate
                  )
                "
                :append-outer-icon="
                  fileListOfShareholders.File ? 'mdi-eye' : ''
                "
                @click:append-outer="viewFilePdf(fileListOfShareholders.File)"
              ></v-file-input>
              <div v-else class="mb-2 d-flex flex-row">
                <v-btn
                  outlined
                  color="secondary"
                  :href="`${apiURl}${fileListOfShareholdersRes.filePath}`"
                  target="_blank"
                  class="mr-4"
                  small
                >
                  <v-icon left> mdi-eye </v-icon>
                  VIEW FILE
                </v-btn>
                <v-btn
                  outlined
                  color="red"
                  @click="
                    remove('ListOfShareholders', fileListOfShareholdersRes.id)
                  "
                  small
                >
                  <v-icon left> mdi-delete </v-icon>
                  REMOVE FILE
                </v-btn>
              </div></v-col
            ><v-col cols="12"
              ><v-divider class="mb-4"></v-divider>
              <v-col cols="12">
                <p>{{ $t("vendor.fileBankStatement") }}</p></v-col
              ></v-col
            ><v-col cols="4">
              <v-file-input
                label="File input"
                v-model="fileBankStatement.File"
                v-if="!fileBankStatementRes.hasFile"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="[
                  (v) => fileValidate(v, 'FinancialStatement', 'File input is required')
                ]"
                :error="!!fileError['FinancialStatement']"
                :error-messages="fileError['FinancialStatement'] || ''"
                required
                @change="
                  setModelofFileNew(
                    fileBankStatement.File,
                    'FinancialStatement'
                  )
                "
                :append-outer-icon="fileBankStatement.File ? 'mdi-eye' : ''"
                @click:append-outer="viewFilePdf(fileBankStatement.File)"
              ></v-file-input>
              <div v-else class="mb-2 d-flex flex-row">
                <v-btn
                  outlined
                  color="secondary"
                  :href="`${apiURl}${fileBankStatementRes.filePath}`"
                  target="_blank"
                  class="mr-4"
                  small
                >
                  <v-icon left> mdi-eye </v-icon>
                  VIEW FILE
                </v-btn>
                <v-btn
                  outlined
                  small
                  color="red"
                  @click="remove('FinancialStatement', fileBankStatementRes.id)"
                >
                  <v-icon left> mdi-delete </v-icon>
                  REMOVE FILE
                </v-btn>
              </div></v-col
            ><v-col cols="12"><v-divider class="mb-4"></v-divider></v-col>
          </v-row>
          <!-- isGov -->
          <v-row
            align="center"
            class="pa-4"
            v-if="isGov && propVendorType !== 'oversea'"
          >
            <v-col cols="12">
              <p>
                {{ $t("vendor.fileGovernmentAgencyEstablishment") }}
              </p></v-col
            ><v-col cols="4">
              <v-file-input
                label="File input"
                v-model="fileGovernmentAgencyEstablishment.File"
                v-if="!fileGovernmentAgencyEstablishmentRes.hasFile"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="[
                  (v) => fileValidate(v, 'GovernmentAgencyEstablishment')
                ]"
                :error="!!fileError['GovernmentAgencyEstablishment']"
                :error-messages="fileError['GovernmentAgencyEstablishment'] || ''"
                @change="
                  setModelofFileNew(
                    fileGovernmentAgencyEstablishment.File,
                    'GovernmentAgencyEstablishment'
                  )
                "
                :append-outer-icon="
                  fileGovernmentAgencyEstablishment.File ? 'mdi-eye' : ''
                "
                @click:append-outer="
                  viewFilePdf(fileGovernmentAgencyEstablishment.File)
                "
              ></v-file-input>
              <div v-else class="mb-2 d-flex flex-row">
                <v-btn
                  outlined
                  color="secondary"
                  :href="`${apiURl}${fileGovernmentAgencyEstablishmentRes.filePath}`"
                  target="_blank"
                  class="mr-4"
                  small
                >
                  <v-icon left> mdi-eye </v-icon>
                  VIEW FILE
                </v-btn>
                <v-btn
                  outlined
                  color="red"
                  @click="
                    remove(
                      'GovernmentAgencyEstablishment',
                      fileGovernmentAgencyEstablishmentRes.id
                    )
                  "
                  small
                >
                  <v-icon left> mdi-delete </v-icon>
                  REMOVE FILE
                </v-btn>
              </div></v-col
            ><v-col cols="12"><v-divider class="mb-4"></v-divider></v-col
          ></v-row>
          <!-- other -->
          <v-row align="center" class="pa-4 mt-n10">
            <v-col cols="12">
              <p>{{ $t("vendor.fileOthers") }}</p></v-col
            ><v-col cols="4">
              <v-file-input
                v-if="!fileOthersRes.hasFile"
                label="File input"
                v-model="fileOthers.File"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="[
                  (v) => fileValidate(v, 'Others')
                ]"
                :error="!!fileError['Others']"
                :error-messages="fileError['Others'] || ''"
                @change="setModelofFileNew(fileOthers.File, 'Others')"
                :append-outer-icon="fileOthers.File ? 'mdi-eye' : ''"
                @click:append-outer="viewFilePdf(fileOthers.File)"
              ></v-file-input>
              <div v-else class="mb-2 d-flex flex-row">
                <v-btn
                  outlined
                  color="secondary"
                  :href="`${apiURl}${fileOthersRes.filePath}`"
                  target="_blank"
                  class="mr-4"
                  small
                >
                  <v-icon left> mdi-eye </v-icon>
                  VIEW FILE
                </v-btn>
                <v-btn
                  outlined
                  color="red"
                  @click="remove('Others', fileOthersRes.id)"
                  small
                >
                  <v-icon left> mdi-delete </v-icon>
                  REMOVE FILE
                </v-btn>
              </div></v-col
            ><v-col cols="12"><v-divider class="mb-4"></v-divider></v-col>
            <v-col cols="12">
              <p>
                {{ $t("vendor.fileTurnoverDating") }}
              </p></v-col
            >
            <v-col cols="4">
              <v-select
                outlined
                dense
                v-model="attachmentModel.year1year"
                :items="year_list"
                :rules="[(v) => !!v || 'Year is required']"
                :label="$t('vendor.year')"
                required
                item-text="year"
                item-value="year"
                class="form-select"
                id="currency"
                name="currency"
              >
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                outlined
                dense
                v-model="attachmentModel.year2year"
                :items="year_list"
                :rules="[(v) => !!v || 'Year is required']"
                :label="$t('vendor.year')"
                required
                item-text="year"
                item-value="year"
                class="form-select"
                id="currency"
                name="currency"
              >
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                outlined
                dense
                v-model="attachmentModel.year3year"
                :items="year_list"
                :rules="[(v) => !!v || 'Year is required']"
                :label="$t('vendor.year')"
                required
                item-text="year"
                item-value="year"
                class="form-select"
                id="currency"
                name="currency"
              >
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-file-input
                :label="$t('vendor.year1')"
                v-model="fileTurnoverDatingYear1.File"
                :rules="[
                  (v) => fileValidate(v, 'TurnoverDatingYear1', 'File input is required')
                ]"
                :error="!!fileError['TurnoverDatingYear1']"
                :error-messages="fileError['TurnoverDatingYear1'] || ''"
                required
                v-if="!fileTurnoverDatingYear1Res.hasFile"
                outlined
                dense
                show-size
                accept=".pdf"
                @change="
                  setModelofFileNew(
                    fileTurnoverDatingYear1.File,
                    'TurnoverDatingYear1'
                  )
                "
                :append-outer-icon="
                  fileTurnoverDatingYear1.File ? 'mdi-eye' : ''
                "
                @click:append-outer="viewFilePdf(fileTurnoverDatingYear1.File)"
              ></v-file-input>
              <div v-else class="mb-2 line-right">
                <p class="mb-2">{{ $t("vendor.year1") }}</p>
                <div class="d-flex flex-row">
                  <v-btn
                    outlined
                    color="secondary"
                    :href="`${apiURl}${fileTurnoverDatingYear1Res.filePath}`"
                    target="_blank"
                    class="mr-4"
                    small
                  >
                    <v-icon left> mdi-eye </v-icon>
                    VIEW FILE
                  </v-btn>
                  <v-btn
                    outlined
                    small
                    color="red"
                    @click="
                      remove(
                        'TurnoverDatingYear1',
                        fileTurnoverDatingYear1Res.id
                      )
                    "
                  >
                    <v-icon left> mdi-delete </v-icon>
                    REMOVE FILE
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="4">
              <v-file-input
                :label="$t('vendor.year2')"
                v-model="fileTurnoverDatingYear2.File"
                :rules="[
                  (v) => fileValidate(v, 'TurnoverDatingYear2', 'File input is required')
                ]"
                :error="!!fileError['TurnoverDatingYear2']"
                :error-messages="fileError['TurnoverDatingYear2'] || ''"
                required
                v-if="!fileTurnoverDatingYear2Res.hasFile"
                outlined
                dense
                show-size
                truncate-length="15"
                accept=".pdf"
                @change="
                  setModelofFileNew(
                    fileTurnoverDatingYear2.File,
                    'TurnoverDatingYear2'
                  )
                "
                :append-outer-icon="
                  fileTurnoverDatingYear2.File ? 'mdi-eye' : ''
                "
                @click:append-outer="viewFilePdf(fileTurnoverDatingYear2.File)"
              ></v-file-input>
              <div v-else class="mb-2 line-right">
                <p class="mb-2">{{ $t("vendor.year2") }}</p>
                <div class="d-flex flex-row">
                  <v-btn
                    outlined
                    color="secondary"
                    :href="`${apiURl}${fileTurnoverDatingYear2Res.filePath}`"
                    target="_blank"
                    class="mr-4"
                    small
                  >
                    <v-icon left> mdi-eye </v-icon>
                    VIEW FILE
                  </v-btn>
                  <v-btn
                    outlined
                    small
                    color="red"
                    @click="
                      remove(
                        'TurnoverDatingYear2',
                        fileTurnoverDatingYear2Res.id
                      )
                    "
                  >
                    <v-icon left> mdi-delete </v-icon>
                    REMOVE FILE
                  </v-btn>
                </div>
              </div> </v-col
            ><v-col cols="4">
              <v-file-input
                :label="$t('vendor.year3')"
                v-model="fileTurnoverDatingYear3.File"
                :rules="[
                  (v) => fileValidate(v, 'TurnoverDatingYear3', 'File input is required')
                ]"
                :error="!!fileError['TurnoverDatingYear3']"
                :error-messages="fileError['TurnoverDatingYear3'] || ''"
                required
                v-if="!fileTurnoverDatingYear3Res.hasFile"
                outlined
                dense
                show-size
                accept=".pdf"
                @change="
                  setModelofFileNew(
                    fileTurnoverDatingYear3.File,
                    'TurnoverDatingYear3'
                  )
                "
                :append-outer-icon="
                  fileTurnoverDatingYear3.File ? 'mdi-eye' : ''
                "
                @click:append-outer="viewFilePdf(fileTurnoverDatingYear3.File)"
              ></v-file-input>
              <div v-else class="mb-2 line-lelf">
                <p class="mb-2">{{ $t("vendor.year3") }}</p>
                <div class="d-flex flex-row">
                  <v-btn
                    outlined
                    color="secondary"
                    small
                    :href="`${apiURl}${fileTurnoverDatingYear3Res.filePath}`"
                    target="_blank"
                    class="mr-4"
                  >
                    <v-icon left> mdi-eye </v-icon>
                    VIEW FILE
                  </v-btn>
                  <v-btn
                    outlined
                    color="red"
                    small
                    @click="
                      remove(
                        'TurnoverDatingYear3',
                        fileTurnoverDatingYear3Res.id
                      )
                    "
                  >
                    <v-icon left> mdi-delete </v-icon>
                    REMOVE FILE
                  </v-btn>
                </div>
              </div></v-col
            >
            <v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="attachmentModel.companyTurnOver1"
                :label="$t('vendor.companyTurnOver')"
                required
                :rules="[(v) => !!v || 'CompanyTurnOver 1 is required']"
                @input="formatNumber($event, 'companyTurnOver1')"
                @change="calRevenueDatingyYear1()"
              ></v-text-field> </v-col
            ><v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="attachmentModel.companyTurnOver2"
                :label="$t('vendor.companyTurnOver')"
                required
                :rules="[(v) => !!v || 'CompanyTurnOver 2 is required']"
                @input="formatNumber($event, 'companyTurnOver2')"
                @change="calRevenueDatingyYear2()"
              ></v-text-field> </v-col
            ><v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="attachmentModel.companyTurnOver3"
                :label="$t('vendor.companyTurnOver')"
                required
                :rules="[(v) => !!v || 'CompanyTurnOver 3 is required']"
                @input="formatNumber($event, 'companyTurnOver3')"
                @change="calRevenueDatingyYear3()"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                outlined
                dense
                v-model="attachmentModel.currency1"
                :items="currency_list"
                :rules="[(v) => !!v || 'Currency is required']"
                :label="$t('vendor.currency')"
                required
                item-text="code"
                item-value="code"
                @change="getcurrency1(attachmentModel.currency1)"
                class="form-select"
                id="currency"
                name="currency"
              >
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                outlined
                dense
                v-model="attachmentModel.currency2"
                :items="currency_list"
                :rules="[(v) => !!v || 'Currency is required']"
                :label="$t('vendor.currency')"
                required
                item-text="code"
                item-value="code"
                @change="getcurrency2(attachmentModel.currency2)"
                class="form-select"
                id="currency"
                name="currency"
              >
              </v-select> </v-col
            ><v-col cols="4">
              <v-select
                outlined
                dense
                v-model="attachmentModel.currency3"
                :items="currency_list"
                :rules="[(v) => !!v || 'Currency is required']"
                :label="$t('vendor.currency')"
                required
                item-text="code"
                item-value="code"
                @change="getcurrency3(attachmentModel.currency3)"
                class="form-select"
                id="currency"
                name="currency"
              >
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="attachmentModel.fxrate1"
                :label="$t('vendor.fxrate')"
                required
                :rules="[(v) => !!v || 'Fx Rate is required']"
                @change="calRevenueDatingyYear1()"
              ></v-text-field> </v-col
            ><v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="attachmentModel.fxrate2"
                :label="$t('vendor.fxrate')"
                required
                :rules="[(v) => !!v || 'Fx Rate is required']"
                @change="calRevenueDatingyYear2()"
              ></v-text-field> </v-col
            ><v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="attachmentModel.fxrate3"
                :label="$t('vendor.fxrate')"
                required
                :rules="[(v) => !!v || 'Fx Rate is required']"
                @change="calRevenueDatingyYear3()"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                disabled
                outlined
                dense
                v-model="thbath1"
                :label="$t('vendor.thbath')"
              ></v-text-field> </v-col
            ><v-col cols="4">
              <v-text-field
                disabled
                outlined
                dense
                v-model="thbath2"
                :label="$t('vendor.thbath')"
              ></v-text-field> </v-col
            ><v-col cols="4">
              <v-text-field
                disabled
                outlined
                dense
                v-model="thbath3"
                :label="$t('vendor.thbath')"
              ></v-text-field>
            </v-col>

            <v-col cols="12"><v-divider class="mb-4"></v-divider></v-col
            ><v-col cols="12">
              <p>
                {{ $t("vendor.experienceYear") }}
              </p></v-col
            >
            <v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="descriptionModel.ExperienceYear"
                :label="$t('vendor.experience')"
                required
                v-mask="'#####'"
                @input="formatYear($event)"
                :rules="[(v) => !!v || 'Experience years is required']"
              ></v-text-field
            ></v-col>
            <v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="descriptionModel.ExperienceIn"
                :label="$t('vendor.experienceIn')"
                required
                @input="(v) => {
                  descriptionModel.ExperienceIn = v.trim();
                }"
                :rules="[(v) => !!v.trim() || 'Experience in business is required']"
              ></v-text-field></v-col
            ><v-col cols="4">
              <v-file-input
                v-model="fileWhichIndustriesExp.File"
                v-if="!fileWhichIndustriesExpRes.hasFile"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="[
                  (v) => fileValidate(v, 'WhichIndustriesExp')
                ]"
                :error="!!fileError['WhichIndustriesExp']"
                :error-messages="fileError['WhichIndustriesExp'] || ''"
                @change="
                  setModelofFileNew(
                    fileWhichIndustriesExp.File,
                    'WhichIndustriesExp'
                  )
                "
                :append-outer-icon="
                  fileWhichIndustriesExp.File ? 'mdi-eye' : ''
                "
                @click:append-outer="viewFilePdf(fileWhichIndustriesExp.File)"
              ></v-file-input>
              <div v-else class="mb-2 d-flex flex-row">
                <v-btn
                  outlined
                  color="secondary"
                  :href="`${apiURl}${fileWhichIndustriesExpRes.filePath}`"
                  target="_blank"
                  class="mr-4"
                  small
                >
                  <v-icon left> mdi-eye </v-icon>
                  VIEW FILE
                </v-btn>
                <v-btn
                  outlined
                  color="red"
                  small
                  @click="
                    remove('WhichIndustriesExp', fileWhichIndustriesExpRes.id)
                  "
                >
                  <v-icon left> mdi-delete </v-icon>
                  REMOVE FILE
                </v-btn>
              </div></v-col
            ><v-col cols="12"><v-divider class="mb-4"></v-divider></v-col
            ><v-col cols="12">
              <p>{{ $t("vendor.ISOName") }}</p></v-col
            ><v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="descriptionModel.ISOName"
                :label="$t('certificates')"
              ></v-text-field></v-col
            ><v-col cols="4">
              <v-file-input
                v-model="fileWhatKindCertYouHave.File"
                v-if="!fileWhatKindCertYouHaveRes.hasFile"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="[
                  (v) => fileValidate(v, 'WhatKindCertYouHave')
                ]"
                :error="!!fileError['WhatKindCertYouHave']"
                :error-messages="fileError['WhatKindCertYouHave'] || ''"
                @change="
                  setModelofFileNew(
                    fileWhatKindCertYouHave.File,
                    'WhatKindCertYouHave'
                  )
                "
                :append-outer-icon="
                  fileWhatKindCertYouHave.File ? 'mdi-eye' : ''
                "
                @click:append-outer="viewFilePdf(fileWhatKindCertYouHave.File)"
              ></v-file-input>
              <div v-else class="mb-2 d-flex flex-row">
                <v-btn
                  outlined
                  color="secondary"
                  :href="`${apiURl}${fileWhatKindCertYouHaveRes.filePath}`"
                  target="_blank"
                  class="mr-4"
                  small
                >
                  <v-icon left> mdi-eye </v-icon>
                  VIEW FILE
                </v-btn>
                <v-btn
                  outlined
                  color="red"
                  @click="
                    remove('WhatKindCertYouHave', fileWhatKindCertYouHaveRes.id)
                  "
                  small
                >
                  <v-icon left> mdi-delete </v-icon>
                  REMOVE FILE
                </v-btn>
              </div></v-col
            ><v-col cols="12"><v-divider class="mb-4"></v-divider></v-col
            ><v-col cols="12">
              <p>{{ $t("vendor.licenseName") }}</p></v-col
            ><v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="descriptionModel.LicenseName"
                :label="$t('vendor.licenses')"
              ></v-text-field></v-col
            ><v-col cols="4">
              <v-file-input
                v-model="fileWhatKindLicenseYouHave.File"
                v-if="!fileWhatKindLicenseYouHaveRes.hasFile"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="[
                  (v) => fileValidate(v, 'WhatKindLicenseYouHave')
                ]"
                :error="!!fileError['WhatKindLicenseYouHave']"
                :error-messages="fileError['WhatKindLicenseYouHave'] || ''"
                @change="
                  setModelofFileNew(
                    fileWhatKindLicenseYouHave.File,
                    'WhatKindLicenseYouHave'
                  )
                "
                :append-outer-icon="
                  fileWhatKindLicenseYouHave.File ? 'mdi-eye' : ''
                "
                @click:append-outer="
                  viewFilePdf(fileWhatKindLicenseYouHave.File)
                "
              ></v-file-input>
              <div v-else class="mb-2 d-flex flex-row">
                <v-btn
                  outlined
                  color="secondary"
                  :href="`${apiURl}${fileWhatKindLicenseYouHave.filePath}`"
                  target="_blank"
                  class="mr-4"
                  small
                >
                  <v-icon left> mdi-eye </v-icon>
                  VIEW FILE
                </v-btn>
                <v-btn
                  outlined
                  color="red"
                  @click="
                    remove(
                      'WhatKindLicenseYouHave',
                      fileWhatKindLicenseYouHaveRes.id
                    )
                  "
                  small
                >
                  <v-icon left> mdi-delete </v-icon>
                  REMOVE FILE
                </v-btn>
              </div></v-col
            ><v-col cols="12"><v-divider class="mb-4"></v-divider></v-col
            ><v-col cols="12">
              <v-checkbox
                v-model="isConsent"
                required
                :rules="[(v) => !!v || 'You must agree to continue!']"
              >
                <template v-slot:label>
                  <div>
                    I agree to the Terms and Conditions and Read information of
                    <a
                      href="https://www.gulf.co.th/en/privacy-notice"
                      target="_blank"
                      rel="noopener"
                      @click.stop
                    >
                      Privacy Notice
                    </a>
                    and
                    <a
                      :href="$router.resolve({ path: `/${$route.params.lang.toLowerCase()}/consentpdpa/readonly` }).href"
                      target="_blank"
                      rel="noopener"
                      @click.stop
                    >
                      Supplement Agreement
                    </a>
                  </div>
                </template>
              </v-checkbox></v-col
            >
            <v-col cols="12"> <p>Comment</p></v-col>
            <v-col cols="12">
              <v-textarea v-model="comment" /><v-divider
                class="mb-4"
              ></v-divider
            ></v-col>
            <!-- Action -->
          </v-row></v-form
        >
      </v-card-text></v-card
    >
  </div>
</template>

<script>
// import { masterservice } from "../../services/masterservice";
import { apiConfig } from "../../services/config";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { vendorservice } from "../../services/vendorservice";
import { viewFile } from "../../util/view-file";
const currencyMask = createNumberMask({
  prefix: "",
  allowDecimal: true,
  includeThousandsSeparator: true,
  allowNegative: true,
});
export default {
  name: "AttachedFileComponent",
  props: {
    propUserName: {
      type: String,
      required: true,
      default: "",
    },
    propVendorID: {
      type: Number,
      default: 0,
    },
    propType: {
      type: String,
      required: true,
    },
    propAttachment: {
      type: [Array, Object],
      require: false,
      default: () => [],
    },
    propAttachmentDescription: {
      type: [Array, Object],
      require: false,
      default: () => {},
    },
    formType: {
      type: String,
      default: "Register",
    },
    propCompanyEstablishDate: {
      type: String,
      default: () => "",
    },
    propCheckStep: {
      type: [Number, String],
      default: () => "",
    },
    propVendorType: { type: String, default: () => "" },
  },
  data: () => ({
    popupConsentpdpa: false,
    // fileIdCard
    currencyMask,
    userName: "",
    vendorId: 0,
    rulesRegisteredCapital: [
      (v) => !!v || "Registered Capital is required",
      (v) => (v && v > 0) || "Registered capital must be more than 0 baht",
    ],
    year_list: [
      { year: 2020 },
      { year: 2021 },
      { year: 2022 },
      { year: 2023 },
      { year: 2024 },
      { year: 2025 },
      { year: 2026 },
      { year: 2027 },
      { year: 2028 },
      { year: 2029 },
      { year: 2030 },
    ],
    currency_list: [
      { name: "Thai Baht", code: "THB" },
      { name: "Afghan Afghani", code: "AFA" },
      { name: "Albanian Lek", code: "ALL" },
      { name: "Algerian Dinar", code: "DZD" },
      { name: "Angolan Kwanza", code: "AOA" },
      { name: "Argentine Peso", code: "ARS" },
      { name: "Armenian Dram", code: "AMD" },
      { name: "Aruban Florin", code: "AWG" },
      { name: "Australian Dollar", code: "AUD" },
      { name: "Azerbaijani Manat", code: "AZN" },
      { name: "Bahamian Dollar", code: "BSD" },
      { name: "Bahraini Dinar", code: "BHD" },
      { name: "Bangladeshi Taka", code: "BDT" },
      { name: "Barbadian Dollar", code: "BBD" },
      { name: "Belarusian Ruble", code: "BYR" },
      { name: "Belgian Franc", code: "BEF" },
      { name: "Belize Dollar", code: "BZD" },
      { name: "Bermudan Dollar", code: "BMD" },
      { name: "Bhutanese Ngultrum", code: "BTN" },
      { name: "Bitcoin", code: "BTC" },
      { name: "Bolivian Boliviano", code: "BOB" },
      { name: "Bosnia-Herzegovina Convertible Mark", code: "BAM" },
      { name: "Botswanan Pula", code: "BWP" },
      { name: "Brazilian Real", code: "BRL" },
      { name: "British Pound Sterling", code: "GBP" },
      { name: "Brunei Dollar", code: "BND" },
      { name: "Bulgarian Lev", code: "BGN" },
      { name: "Burundian Franc", code: "BIF" },
      { name: "Cambodian Riel", code: "KHR" },
      { name: "Canadian Dollar", code: "CAD" },
      { name: "Cape Verdean Escudo", code: "CVE" },
      { name: "Cayman Islands Dollar", code: "KYD" },
      { name: "CFA Franc BCEAO", code: "XOF" },
      { name: "CFA Franc BEAC", code: "XAF" },
      { name: "CFP Franc", code: "XPF" },
      { name: "Chilean Peso", code: "CLP" },
      { name: "Chilean Unit of Account", code: "CLF" },
      { name: "Chinese Yuan", code: "CNY" },
      { name: "Colombian Peso", code: "COP" },
      { name: "Comorian Franc", code: "KMF" },
      { name: "Congolese Franc", code: "CDF" },
      { name: "Costa Rican Colón", code: "CRC" },
      { name: "Croatian Kuna", code: "HRK" },
      { name: "Cuban Convertible Peso", code: "CUC" },
      { name: "Czech Republic Koruna", code: "CZK" },
      { name: "Danish Krone", code: "DKK" },
      { name: "Djiboutian Franc", code: "DJF" },
      { name: "Dominican Peso", code: "DOP" },
      { name: "East Caribbean Dollar", code: "XCD" },
      { name: "Egyptian Pound", code: "EGP" },
      { name: "Eritrean Nakfa", code: "ERN" },
      { name: "Estonian Kroon", code: "EEK" },
      { name: "Ethiopian Birr", code: "ETB" },
      { name: "Euro", code: "EUR" },
      { name: "Falkland Islands Pound", code: "FKP" },
      { name: "Fijian Dollar", code: "FJD" },
      { name: "Gambian Dalasi", code: "GMD" },
      { name: "Georgian Lari", code: "GEL" },
      { name: "German Mark", code: "DEM" },
      { name: "Ghanaian Cedi", code: "GHS" },
      { name: "Gibraltar Pound", code: "GIP" },
      { name: "Greek Drachma", code: "GRD" },
      { name: "Guatemalan Quetzal", code: "GTQ" },
      { name: "Guinean Franc", code: "GNF" },
      { name: "Guyanaese Dollar", code: "GYD" },
      { name: "Haitian Gourde", code: "HTG" },
      { name: "Honduran Lempira", code: "HNL" },
      { name: "Hong Kong Dollar", code: "HKD" },
      { name: "Hungarian Forint", code: "HUF" },
      { name: "Icelandic Króna", code: "ISK" },
      { name: "Indian Rupee", code: "INR" },
      { name: "Indonesian Rupiah", code: "IDR" },
      { name: "Iranian Rial", code: "IRR" },
      { name: "Iraqi Dinar", code: "IQD" },
      { name: "Israeli New Sheqel", code: "ILS" },
      { name: "Italian Lira", code: "ITL" },
      { name: "Jamaican Dollar", code: "JMD" },
      { name: "Japanese Yen", code: "JPY" },
      { name: "Jordanian Dinar", code: "JOD" },
      { name: "Kazakhstani Tenge", code: "KZT" },
      { name: "Kenyan Shilling", code: "KES" },
      { name: "Kuwaiti Dinar", code: "KWD" },
      { name: "Kyrgystani Som", code: "KGS" },
      { name: "Laotian Kip", code: "LAK" },
      { name: "Latvian Lats", code: "LVL" },
      { name: "Lebanese Pound", code: "LBP" },
      { name: "Lesotho Loti", code: "LSL" },
      { name: "Liberian Dollar", code: "LRD" },
      { name: "Libyan Dinar", code: "LYD" },
      { name: "Litecoin", code: "LTC" },
      { name: "Lithuanian Litas", code: "LTL" },
      { name: "Macanese Pataca", code: "MOP" },
      { name: "Macedonian Denar", code: "MKD" },
      { name: "Malagasy Ariary", code: "MGA" },
      { name: "Malawian Kwacha", code: "MWK" },
      { name: "Malaysian Ringgit", code: "MYR" },
      { name: "Maldivian Rufiyaa", code: "MVR" },
      { name: "Mauritanian Ouguiya", code: "MRO" },
      { name: "Mauritian Rupee", code: "MUR" },
      { name: "Mexican Peso", code: "MXN" },
      { name: "Moldovan Leu", code: "MDL" },
      { name: "Mongolian Tugrik", code: "MNT" },
      { name: "Moroccan Dirham", code: "MAD" },
      { name: "Mozambican Metical", code: "MZM" },
      { name: "Myanmar Kyat", code: "MMK" },
      { name: "Namibian Dollar", code: "NAD" },
      { name: "Nepalese Rupee", code: "NPR" },
      { name: "Netherlands Antillean Guilder", code: "ANG" },
      { name: "New Taiwan Dollar", code: "TWD" },
      { name: "New Zealand Dollar", code: "NZD" },
      { name: "Nicaraguan Córdoba", code: "NIO" },
      { name: "Nigerian Naira", code: "NGN" },
      { name: "North Korean Won", code: "KPW" },
      { name: "Norwegian Krone", code: "NOK" },
      { name: "Omani Rial", code: "OMR" },
      { name: "Pakistani Rupee", code: "PKR" },
      { name: "Panamanian Balboa", code: "PAB" },
      { name: "Papua New Guinean Kina", code: "PGK" },
      { name: "Paraguayan Guarani", code: "PYG" },
      { name: "Peruvian Nuevo Sol", code: "PEN" },
      { name: "Philippine Peso", code: "PHP" },
      { name: "Polish Zloty", code: "PLN" },
      { name: "Qatari Rial", code: "QAR" },
      { name: "Romanian Leu", code: "RON" },
      { name: "Russian Ruble", code: "RUB" },
      { name: "Rwandan Franc", code: "RWF" },
      { name: "Salvadoran Colón", code: "SVC" },
      { name: "Samoan Tala", code: "WST" },
      { name: "São Tomé and Príncipe Dobra", code: "STD" },
      { name: "Saudi Riyal", code: "SAR" },
      { name: "Serbian Dinar", code: "RSD" },
      { name: "Seychellois Rupee", code: "SCR" },
      { name: "Sierra Leonean Leone", code: "SLL" },
      { name: "Singapore Dollar", code: "SGD" },
      { name: "Slovak Koruna", code: "SKK" },
      { name: "Solomon Islands Dollar", code: "SBD" },
      { name: "Somali Shilling", code: "SOS" },
      { name: "South African Rand", code: "ZAR" },
      { name: "South Korean Won", code: "KRW" },
      { name: "South Sudanese Pound", code: "SSP" },
      { name: "Special Drawing Rights", code: "XDR" },
      { name: "Sri Lankan Rupee", code: "LKR" },
      { name: "St. Helena Pound", code: "SHP" },
      { name: "Sudanese Pound", code: "SDG" },
      { name: "Surinamese Dollar", code: "SRD" },
      { name: "Swazi Lilangeni", code: "SZL" },
      { name: "Swedish Krona", code: "SEK" },
      { name: "Swiss Franc", code: "CHF" },
      { name: "Syrian Pound", code: "SYP" },
      { name: "Tajikistani Somoni", code: "TJS" },
      { name: "Tanzanian Shilling", code: "TZS" },

      { name: "Tongan Pa'anga", code: "TOP" },
      { name: "Trinidad & Tobago Dollar", code: "TTD" },
      { name: "Tunisian Dinar", code: "TND" },
      { name: "Turkish Lira", code: "TRY" },
      { name: "Turkmenistani Manat", code: "TMT" },
      { name: "Ugandan Shilling", code: "UGX" },
      { name: "Ukrainian Hryvnia", code: "UAH" },
      { name: "United Arab Emirates Dirham", code: "AED" },
      { name: "Uruguayan Peso", code: "UYU" },
      { name: "US Dollar", code: "USD" },
      { name: "Uzbekistan Som", code: "UZS" },
      { name: "Vanuatu Vatu", code: "VUV" },
      { name: "Venezuelan BolÃvar", code: "VEF" },
      { name: "Vietnamese Dong", code: "VND" },
      { name: "Yemeni Rial", code: "YER" },
      { name: "Zambian Kwacha", code: "ZMK" },
      { name: "Zimbabwean dollar", code: "ZWL" },
    ],

    currency1: "",
    currency2: "",
    currency3: "",
    fxrate1: 0,
    fxrate2: 0,
    fxrate3: 0,
    thbath1: 0,
    thbath2: 0,
    thbath3: 0,

    companyturnover1: 0,
    companyturnover2: 0,
    companyturnover3: 0,

    apiURl: apiConfig,
    descriptionModel: {
      RegisteredCapital: "",
      ExperienceIn: "",
      ExperienceYear: "",
      ISOName: "",
      LicenseName: "",
    },
    fileCopyOfVATRegistrationCerRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    fileCopyOfVATRegistrationCer: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "CopyOfVATRegistrationCer",
      Description: "",
      File: null,
    },
    fileFromKYCRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    fileFromKYC: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "FromKYC",
      Description: "",
      File: null,
    },
    // file affidavit
    fileAffidavit: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "Affidavit",
      Description: "",
      ExpireDate: "",
      File: null,
    },
    // file resource
    fileAffidavitRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    fileListOfShareholders: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "ListOfShareholders",
      Description: "",
      ExpireDate: "",
      File: null,
    },
    // file resource
    fileListOfShareholdersRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    fileBankStatement: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "FinancialStatement",
      Description: "",
      File: null,
    },
    // file resource
    fileBankStatementRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },

    fileOthers: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "Others",
      Description: "",
      File: null,
    },
    // file resource
    fileOthersRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },

    fileRevenueDatingyYear1: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "RevenueDatingyYear1",
      Description: "",
      File: null,
    },
    // file resource
    fileRevenueDatingyYear1Res: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },

    fileRevenueDatingyYear2: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "RevenueDatingyYear2",
      Description: "",
      File: null,
    },
    // file resource
    fileRevenueDatingyYear2Res: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },

    fileRevenueDatingyYear3: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "RevenueDatingyYear3",
      Description: "",
      File: null,
    },
    // file resource
    fileRevenueDatingyYear3Res: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },

    fileTurnoverDatingYear1: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "TurnoverDatingYear1",
      Description: "",

      File: null,
    },
    // file resource
    fileTurnoverDatingYear1Res: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
      fxrate: "",
      thbath: 0,
      currency: "",
      companyturnover: 0,
    },

    fileTurnoverDatingYear2: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "TurnoverDatingYear2",
      Description: "",

      File: null,
    },
    // file resource
    fileTurnoverDatingYear2Res: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
      fxrate: "",
      thbath: 0,
      currency: "",
      companyturnover: 0,
    },
    fileTurnoverDatingYear3: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "TurnoverDatingYear3",
      Description: "",

      File: null,
    },
    // file resource
    fileTurnoverDatingYear3Res: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
      fxrate: "",
      thbath: 0,
      currency: "",
      companyturnover: 0,
    },
    fileWhichIndustriesExp: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "WhichIndustriesExp",
      Description: "",
      File: null,
    },
    // file resource
    fileWhichIndustriesExpRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    fileWhatKindCertYouHave: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "WhatKindCertYouHave",
      Description: "",
      File: null,
    },
    // file resource
    fileWhatKindCertYouHaveRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    fileWhatKindLicenseYouHave: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "WhatKindLicenseYouHave",
      Description: "",
      File: null,
    },
    // file resource
    fileWhatKindLicenseYouHaveRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // Payload file to formdata
    fileIdCard: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "IdCard",
      Description: "",
      ExpireDate: "",
      File: null,
    },
    // file resource
    fileIdCardRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // idCard
    fileCopyBankPassbook: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "CopyBankPassbook",
      Description: "",
      File: null,
    },
    // file resource
    fileCopyBankPassbookRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    fileCertificate: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "Certificate",
      Description: "",
      ExpireDate: "",
      File: null,
    },
    // file resource
    fileCertificateRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file house registration
    fileHouseRegistration: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "HouseRegistration",
      Description: "",
      File: null,
    },
    // file resource
    fileHouseRegistrationRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    fileGovernmentAgencyEstablishment: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "GovernmentAgencyEstablishment",
      Description: "",
      File: null,
    },
    // file resource
    fileGovernmentAgencyEstablishmentRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    fileRegisteredCapital: {
      UserName: "",
      VendorId: 0,
      AttachmentType: "RegisteredCapital",
      Description: "",
      File: null,
    },
    // file resource
    fileRegisteredCapitalRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    isConsent: false,
    comment: "",
    companyEstablishDate: null,
    testAttachment: [],
    attachmentModel: [],

    valid: true,
    activePickerAffidavit: null,
    activePickerIdCard: null,
    activePickerIssue: null,

    menuPickerAffidavit: false,
    menuPickerIdCard: false,
    menuPickerIssue: false,

    fileError: {},
  }),
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    // 1=Ordinary, 2=Juristic, 3=Government
    isOrdinary() {
      if (this.propType == "1") return true;
      return false;
    },
    isJuristic() {
      if (this.propType === "2") return true;
      return false;
    },
    isGov() {
      if (this.propType === "3") return true;
      return false;
    },
  },
  watch: {
    menuPickerAffidavit(val) {
      val && setTimeout(() => (this.activePickerAffidavit = "YEAR"));
    },
    menuPickerIdCard(val) {
      val && setTimeout(() => (this.activePickerIdCard = "YEAR"));
    },
    menuPickerIssue(val) {
      val && setTimeout(() => (this.activePickerIssue = "YEAR"));
    },
    propCheckStep(value) {
      if (value === 5) {
        this.validate();
      }
    },
    propUserName(value) {
      if (value) {
        this.userName = value;
        this.setModelofFile();
      }
    },
    propVendorID(value) {
      if (value) this.vendorId = value;
    },
    propAttachment(value) {
      if (value) {
        if (this.formType === "Edit") {
          this.attachments = value;
          this.getIshasFile();
        }
      }
    },
    propAttachmentDescription(value) {
      if (value) this.descriptionModel = value;
    },
    isConsent(value) {
      this.$emit("EmitIsConsent", value);
    },
    propCompanyEstablishDate(value) {
      if (this.formType === "Register") {
        this.companyEstablishDate = value;
        this.checkDateExperience();
      }
    },
    attachmentModel: {
      deep: true,
      handler(newVal) {
        // Format turnover values when they are updated
        ["companyTurnOver1", "companyTurnOver2", "companyTurnOver3"].forEach(
          (field) => {
            if (newVal[field] && !newVal[field].includes(",")) {
              this.formatNumber(newVal[field].toString(), field);
            }
          }
        );
      },
    },
    // "attachmentModel.companyTurnOver1"(value){

    //   //const withoutCommas = this.attachmentModel.companyTurnOver1.replaceAll(',', '');
    //   //this.attachmentModel.thbath1= value.thbath1;
    //   console.log('tao',value)
    // },
    // "attachmentModel.companyTurnOver1"(withoutCommas){
    //   console.log(value)
    //   //const withoutCommas = value.replaceAll(',', '');
    //   this.attachmentModel.thbath1=withoutCommas * this.attachmentModel.fxrate1;
    // },
    // "attachmentModel.fxrate2"(value){
    //   console.log(value)
    //   //const withoutCommas = this.attachmentModel.companyTurnOver2.replaceAll(',', '');
    //   this.attachmentModel.thbath2=this.attachmentModel.companyTurnOver2 * value;
    // },
    // "attachmentModel.companyTurnOver2"(value){
    //   console.log(value)
    //   const withoutCommas = value.replaceAll(',', '');
    //   this.attachmentModel.thbath2=value * this.attachmentModel.fxrate2;
    // },
    // "attachmentModel.fxrate3"(value){
    //   console.log(value)
    //   //const withoutCommas = this.attachmentModel.companyTurnOver3.replaceAll(',', '');
    //   this.attachmentModel.thbath3=this.attachmentModel.companyTurnOver3 * value;
    // },
    // "attachmentModel.companyTurnOver3"(value){
    //   console.log('companyTurnOver3',value)
    //   //const withoutCommas = value.replaceAll(',', '');
    //   this.attachmentModel.thbath3=value * this.attachmentModel.fxrate3;
    //   console.log('companyTurnOver3',this.attachmentModel.thbath3)
    // },
  },
  mounted() {
    if (this.formType === "Edit") {
      this.descriptionModel = this.propAttachmentDescription;
      // Format initial turnover values
      ["companyTurnOver1", "companyTurnOver2", "companyTurnOver3"].forEach(
        (field) => {
          if (this.attachmentModel[field]) {
            this.formatNumber(this.attachmentModel[field].toString(), field);
          }
        }
      );
    } else {
      if (this.formType === "Register") {
        if (this.propCompanyEstablishDate !== null) {
          this.companyEstablishDate = this.propCompanyEstablishDate;
        }
      }
    }
  },
  methods: {
    async getcurrency1(symbols) {
      if (symbols == "THB") {
        this.attachmentModel.fxrate1 = 1;
      } else {
        //       const currentDate = new Date();

        // // Subtract one day's worth of milliseconds (86400000 milliseconds in a day)
        // const previousDate = new Date(currentDate.getTime() - 86400000);

        // // Get individual components of the previous date
        // const year = previousDate.getFullYear();
        // const month = String(previousDate.getMonth() + 1).padStart(2, '0');
        // const day = String(previousDate.getDate()).padStart(2, '0');

        // // Display the previous date in "yyyy-dd-mm" format
        // const formattedPreviousDate = `${year}-${month}-${day}`;

        // var cur= await masterservice.GetCurrency(symbols,formattedPreviousDate);

        // if(cur!=null){

        //   this.attachmentModel.fxrate1=cur.rate;
        //   //this.registerModel.fxrat=10;
        // }else{

        //   this.attachmentModel.fxrate1=0;
        // }
        this.attachmentModel.fxrate1 = 0;
      }
      const cleanedValue = this.attachmentModel.companyTurnOver1.replace(
        /(?<!^)-|[^0-9.-]/g,
        ""
      ); // Remove non-numeric characters

      this.thbath1 = parseFloat(cleanedValue) * this.attachmentModel.fxrate1;
      this.attachmentModel.thbath1 =
        parseFloat(cleanedValue) * this.attachmentModel.fxrate1;
      // console.log(parseFloat(cleanedValue), this.attachmentModel.fxrate1);
    },
    async getcurrency2(symbols) {
      if (symbols == "THB") {
        this.attachmentModel.fxrate2 = 1;
      } else {
        //       const currentDate = new Date();

        // // Subtract one day's worth of milliseconds (86400000 milliseconds in a day)
        // const previousDate = new Date(currentDate.getTime() - 86400000);

        // // Get individual components of the previous date
        // const year = previousDate.getFullYear();
        // const month = String(previousDate.getMonth() + 1).padStart(2, '0');
        // const day = String(previousDate.getDate()).padStart(2, '0');

        // // Display the previous date in "yyyy-dd-mm" format
        // const formattedPreviousDate = `${year}-${month}-${day}`;

        // var cur= await masterservice.GetCurrency(symbols,formattedPreviousDate);

        // if(cur!=null){

        //   this.attachmentModel.fxrate2=cur.rate;
        //   //this.registerModel.fxrat=10;
        // }else{

        //   this.attachmentModel.fxrate2=0;
        // }
        this.attachmentModel.fxrate2 = 0;
      }
      const cleanedValue = this.attachmentModel.companyTurnOver2.replace(
        /(?<!^)-|[^0-9.-]/g,
        ""
      ); // Remove non-numeric characters

      this.thbath2 = parseFloat(cleanedValue) * this.attachmentModel.fxrate2;
      this.attachmentModel.thbath2 =
        parseFloat(cleanedValue) * this.attachmentModel.fxrate2;
    },
    async getcurrency3(symbols) {
      if (symbols == "THB") {
        this.attachmentModel.fxrate3 = 1;
      } else {
        //       const currentDate = new Date();

        // // Subtract one day's worth of milliseconds (86400000 milliseconds in a day)
        // const previousDate = new Date(currentDate.getTime() - 86400000);

        // // Get individual components of the previous date
        // const year = previousDate.getFullYear();
        // const month = String(previousDate.getMonth() + 1).padStart(2, '0');
        // const day = String(previousDate.getDate()).padStart(2, '0');

        // // Display the previous date in "yyyy-dd-mm" format
        // const formattedPreviousDate = `${year}-${month}-${day}`;

        // var cur= await masterservice.GetCurrency(symbols,formattedPreviousDate);

        // if(cur!=null){

        //   this.attachmentModel.fxrate3=cur.rate;
        //   //this.registerModel.fxrat=10;
        // }else{

        //   this.attachmentModel.fxrate3=0;
        // }
        this.attachmentModel.fxrate3 = 0;
      }

      const cleanedValue = this.attachmentModel.companyTurnOver3.replace(
        /(?<!^)-|[^0-9.-]/g,
        ""
      ); // Remove non-numeric characters

      this.thbath3 = parseFloat(cleanedValue) * this.attachmentModel.fxrate3;
      this.attachmentModel.thbath3 =
        parseFloat(cleanedValue) * this.attachmentModel.fxrate3;
    },
    calRevenueDatingyYear1() {
      if (this.attachmentModel.fxrate1 !== undefined) {
        const cleanedValue = this.attachmentModel.companyTurnOver1.replace(
          /(?<!^)-|[^0-9.-]/g,
          ""
        ); // Remove non-numeric characters

        this.thbath1 = parseFloat(cleanedValue) * this.attachmentModel.fxrate1;
        this.attachmentModel.thbath1 =
          parseFloat(cleanedValue) * this.attachmentModel.fxrate1;
      }
    },
    calRevenueDatingyYear2() {
      if (this.attachmentModel.fxrate2 !== undefined) {
        const cleanedValue = this.attachmentModel.companyTurnOver2.replace(
          /(?<!^)-|[^0-9.-]/g,
          ""
        ); // Remove non-numeric characters

        this.thbath2 = parseFloat(cleanedValue) * this.attachmentModel.fxrate2;
        this.attachmentModel.thbath2 =
          parseFloat(cleanedValue) * this.attachmentModel.fxrate2;
      }
    },
    calRevenueDatingyYear3() {
      if (this.attachmentModel.fxrate3 !== undefined) {
        const cleanedValue = this.attachmentModel.companyTurnOver3.replace(
          /(?<!^)-|[^0-9.-]/g,
          ""
        ); // Remove non-numeric characters

        this.thbath3 = parseFloat(cleanedValue) * this.attachmentModel.fxrate3;
        this.attachmentModel.thbath3 =
          parseFloat(cleanedValue) * this.attachmentModel.fxrate3;
      }
    },
    setModelofFile() {
      const FileType = [
        "IdCard",
        "CopyBankPassbook",
        "CopyOfVATRegistrationCer",
        "Certificate",
        "ListOfShareholders",
        "GovernmentAgencyEstablishment",
        "RevenueDatingyYear1",
        "RevenueDatingyYear2",
        "RevenueDatingyYear3",
        "TurnoverDatingYear1",
        "TurnoverDatingYear2",
        "TurnoverDatingYear3",
        "RegisteredCapital",
        "WhichIndustriesExp",
        "WhatKindCertYouHave",
        "WhatKindLicenseYouHave",
        "Others",
        "Affidavit",
        "HouseRegistration",
        "BankStatement",
      ];
      for (let i = 0; i < FileType.length; i++) {
        this[`file${FileType[i]}`].UserName =
          this.userName.length === 13 ? `${this.userName}00000` : this.userName;
        this[`file${FileType[i]}`].VendorId = this.vendorId;
      }
    },
    // Set Model to Connect Api
    setModelofFileNew(
      file,
      FileType,
      Expire,
      Description,
      currency,
      fxrate,
      thbath,
      year,
      companyTurnOver
    ) {
      if (file) {
        const dupIndex = this.attachmentModel.findIndex(
          (element) => element.AttachmentType === FileType
        );
        if (dupIndex < 0) {
          const dataFile = {
            File: file,
            AttachmentType: FileType,
            Description: Description,
            ExpireDate: Expire,
            AttachmentBoqName: file.name,
            VendorId: this.vendorId,
            hasFile: true,
            isNewFile: true,
            currency: currency,
            fxrate: fxrate,
            thbath: thbath,
            year: year,
            companyTurnOver: companyTurnOver,
          };
          this.attachmentModel.push(dataFile);
        } else {
          this.attachmentModel[dupIndex].File = file;
          this.attachmentModel[dupIndex].AttachmentType = FileType;
          this.attachmentModel[dupIndex].Description = Description;
          this.attachmentModel[dupIndex].ExpireDate = Expire;
          this.attachmentModel[dupIndex].AttachmentBoqName = file.name;
          this.attachmentModel[dupIndex].hasFile = true;
          this.attachmentModel[dupIndex].isNewFile = true;
          (this.attachmentModel[dupIndex].currency = currency),
            (this.attachmentModel[dupIndex].fxrate = fxrate),
            (this.attachmentModel[dupIndex].thbath = thbath),
            (this.attachmentModel[dupIndex].year = year),
            (this.attachmentModel[dupIndex].companyTurnOver = companyTurnOver);
        }
      } else {
        const dupIndex = this.attachmentModel.findIndex(
          (element) => element.AttachmentType === FileType
        );
        if (dupIndex < 0) {
          const dataFile = {
            AttachmentType: FileType,
            Description: Description,
            ExpireDate: Expire,
            VendorId: this.vendorId,
            hasFile: true,
            isNewFile: true,
            currency: currency,
            fxrate: fxrate,
            thbath: thbath,
            year: year,
            companyTurnOver: companyTurnOver,
          };
          this.attachmentModel.push(dataFile);
        } else {
          this.attachmentModel[dupIndex].AttachmentType = FileType;
          this.attachmentModel[dupIndex].Description = Description;
          this.attachmentModel[dupIndex].ExpireDate = Expire;
          this.attachmentModel[dupIndex].hasFile = true;
          this.attachmentModel[dupIndex].isNewFile = false;
          (this.attachmentModel[dupIndex].currency = currency),
            (this.attachmentModel[dupIndex].fxrate = fxrate),
            (this.attachmentModel[dupIndex].thbath = thbath),
            (this.attachmentModel[dupIndex].year = year),
            (this.attachmentModel[dupIndex].companyTurnOver = companyTurnOver);
        }
      }
    },
    async validate() {
      await this.$refs.form.validate();
      await this.fileContentValidateAll();
      if (this.valid === true) {
        if (this.attachmentModel.length > 0) {
          for (let i = 0; i < this.attachmentModel.length; i++) {
            if (this.attachmentModel[i].AttachmentType === "Affidavit") {
              await this.setModelofFileNew(
                this.fileAffidavit.File,
                "Affidavit",
                this.fileAffidavit.ExpireDate
              );
            }
            if (this.attachmentModel[i].AttachmentType === "IdCard") {
              await this.setModelofFileNew(
                this.fileIdCard.File,
                "IdCard",
                this.fileIdCard.ExpireDate
              );
            }
            if (
              this.attachmentModel[i].AttachmentType === "ListOfShareholders"
            ) {
              await this.setModelofFileNew(
                this.fileListOfShareholders.File,
                "ListOfShareholders",
                this.fileListOfShareholders.ExpireDate
              );
            }
          }
        }
        this.setModelofFile();
        this.$emit("EmitDescModel", this.descriptionModel);
        this.$emit("EmitSubmitAttachment", this.attachmentModel);
        this.$emit("EmitSubmitAttachmentNext", true);
        this.$emit("EmitComment", this.comment);
      } else {
        window.scrollTo(0,0);
        this.$notify({
          type: "warning",
          title: "Validate failed",
          text: "Some field is required.",
        });
      }
    },
    async fileContentValidate(file, fileType) {
      if (!file) return;
      const header = new Uint8Array(await file.slice(0, 4).arrayBuffer());
      const hex = [...header].map(b => b.toString(16).padStart(2, '0')).join('');
      if (hex !== '25504446') {
        this.fileError = {...this.fileError, [fileType]: 'File is not a valid PDF'};
        this.valid = false;
      }
    },
    async fileContentValidateAll() {
      for (let i = 0; i < this.attachmentModel.length; i++) {
        await this.fileContentValidate(this.attachmentModel[i].File, this.attachmentModel[i].AttachmentType);
      }
    },
    fileValidate(v, fileType, nullMessage) {
      this.fileError = {...this.fileError, [fileType]: ''};
      if (!v) return nullMessage || true;

      const ext = v.name.split('.').pop().toLowerCase();
      if (ext !== 'pdf') return `File type .${ext} not allowed`;

      const maxSize = 31457280;
      if (v.size > maxSize) return 'File size must be less than or equal to 30MB';

      this.fileContentValidate(v, fileType);
      return true;
    },
    checkDateExperience() {
      if (this.companyEstablishDate !== null) {
        const date1 = new Date(this.companyEstablishDate);
        const date2 = new Date();
        const differenceTime = date2.getTime() - date1.getTime();
        const differenceDays = differenceTime / (1000 * 3600 * 24);
        const differenceYears = differenceDays / 360;
        this.descriptionModel.ExperienceYear =
          differenceYears.toFixed(0) < 0 ? 0 : differenceYears.toFixed(0);
      } else {
        this.descriptionModel.ExperienceYear = 0;
      }
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    getIshasFile() {
      const FileType = [
        "IdCard",
        "CopyBankPassbook",
        "CopyOfVATRegistrationCer",
        "Certificate",
        "ListOfShareholders",
        "GovernmentAgencyEstablishment",
        "RevenueDatingyYear1",
        "RevenueDatingyYear2",
        "RevenueDatingyYear3",
        "TurnoverDatingYear1",
        "TurnoverDatingYear2",
        "TurnoverDatingYear3",
        "RegisteredCapital",
        "WhichIndustriesExp",
        "WhatKindCertYouHave",
        "WhatKindLicenseYouHave",
        "Others",
        "Affidavit",
        "HouseRegistration",
        "FinancialStatement",
        "FromKYC",
      ];
      for (let i = 0; i < FileType.length; i++) {
        const resData = this.attachments.find(
          ({ attachmentType }) => attachmentType === FileType[i]
        );
        this.pushDataAttachment(FileType[i], resData);
      }
    },
    pushDataAttachment(attachmentType, data) {
      if (attachmentType === "FinancialStatement") {
        if (data !== undefined) {
          this.fileBankStatementRes.id = data.id;
          this.fileBankStatementRes.fileName = data.fileName;
          this.fileBankStatementRes.filePath = data.filePath;
          this.fileBankStatementRes.hasFile = true;
          this.fileBankStatementRes.ExpireDate = data.issueDate
            ? this.moment(data.issueDate).format("yyyy-MM-DD")
            : "";
          this.setOldFile(attachmentType, data.issueDate, data);
        } else this.fileBankStatementRes.hasFile = false;
      } else {
        if (data != undefined) {
          this[`file${attachmentType}Res`].id = data.id;
          this[`file${attachmentType}Res`].fileName = data.fileName;
          this[`file${attachmentType}Res`].filePath = data.filePath;
          this[`file${attachmentType}Res`].hasFile = true;
          //karun
          if (attachmentType == "TurnoverDatingYear1") {
            // Format the companyTurnOver value before setting it
            const formattedTurnover = this.formatNumberValue(
              data.companyTurnOver
            );
            this.attachmentModel.companyTurnOver1 = formattedTurnover;
            this.attachmentModel.currency1 = data.currency;
            this.attachmentModel.fxrate1 = data.fxrate;
            this.attachmentModel.thbath1 = data.thbath;
            this.thbath1 = data.thbath;
            this.attachmentModel.year1year = parseInt(data.year);
          }
          if (attachmentType == "TurnoverDatingYear2") {
            const formattedTurnover = this.formatNumberValue(
              data.companyTurnOver
            );
            this.attachmentModel.companyTurnOver2 = formattedTurnover;
            this.attachmentModel.currency2 = data.currency;
            this.attachmentModel.fxrate2 = data.fxrate;
            this.attachmentModel.thbath2 = data.thbath;
            this.thbath2 = data.thbath;
            this.attachmentModel.year2year = parseInt(data.year);
          }
          if (attachmentType == "TurnoverDatingYear3") {
            const formattedTurnover = this.formatNumberValue(
              data.companyTurnOver
            );
            this.attachmentModel.companyTurnOver3 = formattedTurnover;
            this.attachmentModel.currency3 = data.currency;
            this.attachmentModel.fxrate3 = data.fxrate;
            this.attachmentModel.thbath3 = data.thbath;
            this.thbath3 = data.thbath;
            this.attachmentModel.year3year = parseInt(data.year);
          }

          this[`file${attachmentType}`].ExpireDate = data.issueDate
            ? this.moment(data.issueDate).format("yyyy-MM-DD")
            : "";
          this.setOldFile(attachmentType, data.issueDate, data);
        } else this[`file${attachmentType}Res`].hasFile = false;
      }
    },
    async remove(fileType, id) {
      if (fileType == "FinancialStatement")
        this.fileBankStatementRes.hasFile = false;
      else {
        this[`file${fileType}Res`].hasFile = false;
      }
      await vendorservice.DeleteVendorAttachment(id);

      const index = this.attachmentModel.findIndex(
        (element) => element.AttachmentType === fileType
      );
      this.attachmentModel[index].File = "";
      this.attachmentModel[index].AttachmentType = "";
      this.attachmentModel[index].Description = "";
      this.attachmentModel[index].ExpireDate = "";
      this.attachmentModel[index].AttachmentBoqName = "";
      this.attachmentModel[index].hasFile = false;
      this.attachmentModel[index].isNewFile = false;
      this.attachmentModel[index].isActive = false;
    },
    setOldFile(FileType, Issue, OldData) {
      if (OldData !== undefined) {
        if (OldData.filePath !== "" && OldData.filePath !== null) {
          const dupIndex = this.attachmentModel.findIndex(
            (element) => element.attachmentTypeName === FileType
          );
          if (dupIndex < 0) {
            const dataFile = {
              File: "",
              AttachmentType: FileType,
              Description: "",
              ExpireDate: Issue,
              AttachmentBoqName: OldData.fileName,
              VendorId: OldData.vendorId,
              hasFile: true,
              isNewFile: false,
            };
            this.attachmentModel.push(dataFile);
          } else {
            this.attachmentModel[dupIndex].File = "";
            this.attachmentModel[dupIndex].AttachmentType = FileType;
            this.attachmentModel[dupIndex].Description = "";
            this.attachmentModel[dupIndex].ExpireDate = Issue
              ? this.moment(Issue).format("yyyy-MM-DD")
              : "";
            this.attachmentModel[dupIndex].AttachmentBoqName = OldData.fileName;
            this.attachmentModel[dupIndex].hasFile = true;
            this.attachmentModel[dupIndex].isNewFile = false;
          }
        }
      }
    },
    async viewFilePdf(file) {
      await viewFile(file);
    },
    checkMinMonth() {
      const d = new Date();
      // console.log(this.moment(d.toLocaleDateString()).format("YYYY-MM-DD"));
      const month = d.getMonth();
      d.setMonth(d.getMonth() - 6);
      while (d.getMonth() === month) {
        d.setDate(d.getDate() - 1);
      }
      // console.log(this.moment(d.toLocaleDateString()).format("YYYY-MM-DD"));
      return this.moment(d.toLocaleDateString()).format("YYYY-MM-DD");
    },
    checkDate(date) {
      var start = this.moment(date).format("YYYY-MM-DD");
      var end = this.moment().format("YYYY-MM-DD");
      const monthDifference = this.moment(new Date(end)).diff(
        new Date(start),
        "months",
        true
      );
      return monthDifference >= 6 ? true : false;
    },
    async formatNumber(value, field) {
      if (!value) return;

      // Remove any non-digit characters except decimal point
      let number = value.replace(/[^\d.-]/g, "");

      // Keep minus only at the very start
      const isNegative = number.startsWith("-");
      number = (isNegative ? "-" : "") + number.replace(/-/g, "");

      // Ensure only one decimal point — keep the first, discard the rest
      const parts = number.split(".");
      if (parts.length > 2) {
        number = parts[0] + "." + parts[1];
      }

      // Format with commas for thousands
      const [integerPart, rawDecimal] = number.split(".");
      const decimalPart = rawDecimal !== undefined ? rawDecimal.slice(0, 2) : undefined;
      const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // Combine integer and decimal parts
      const formattedNumber = decimalPart !== undefined
        ? `${formattedInteger}.${decimalPart}`
        : formattedInteger;

      // Update the model
      await this.$nextTick();
      this.attachmentModel[field] = formattedNumber;
    },
    formatNumberValue(value) {
      if (!value) return "";
      // Convert to string and remove existing commas if any
      const number = value.toString().replace(/,/g, "");
      // Format with commas
      return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async formatYear(value) {
      let num = value.replace(/[^\d]/g, "").replace(/^0*/g, "");
      if (num === "") num = "0";
      await this.$nextTick();
      this.descriptionModel.ExperienceYear = num;
    },
  },
};
</script>
<style lang="scss" scoped>
.col {
  padding: 0 0.5rem;
}
.line-right {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.line-lelf {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
